import { __awaiter } from 'tslib';
import { Magic } from 'magic-sdk';
import { logger } from '../../../../utils/logger.js';

// these are based off of Magic's EthNetworkName type
const chainNameToChainIdMap = {
    arbitrum: 42161,
    avalance: 43114,
    bsc: 56,
    gnosis: 100,
    goerli: 5,
    mainnet: 1,
    optimism: 10,
    polygon: 137,
    sepolia: 11155111,
};
class MagicClientNetworkHandler {
    constructor({ apiKey, evmNetworks, config }) {
        var _a, _b;
        this._clients = {};
        this.evmNetworks = [];
        this._config = config;
        this._apiKey = apiKey;
        this.evmNetworks = evmNetworks;
        if (this.lastUsedNetworkId) {
            this._networkId = this.lastUsedNetworkId;
        }
        else {
            this._networkId =
                typeof (config === null || config === void 0 ? void 0 : config.network) === 'string'
                    ? chainNameToChainIdMap[config.network]
                    : (_b = (_a = config === null || config === void 0 ? void 0 : config.network) === null || _a === void 0 ? void 0 : _a.chainId) !== null && _b !== void 0 ? _b : 1;
        }
    }
    selectNetwork(networkChainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._networkId = networkChainId;
            this.lastUsedNetworkId = networkChainId;
            (_a = this.onChainChanged) === null || _a === void 0 ? void 0 : _a.call(this, networkChainId);
        });
    }
    get networkId() {
        return this._networkId;
    }
    get config() {
        return this._config;
    }
    getClient() {
        const networkId = this._networkId;
        const client = this._clients[networkId];
        if (client) {
            return client;
        }
        const config = this.getConfigForNetwork(networkId);
        const newClient = new Magic(this._apiKey, config);
        this._clients[networkId] = newClient;
        return newClient;
    }
    getConfigForNetwork(networkId) {
        const rpcUrl = this._getRpcUrlByNetworkId(networkId);
        // Should prioritize custom rpc config form dashboard
        if (rpcUrl) {
            return Object.assign(Object.assign({}, this._config), { network: {
                    chainId: this._getChainIdByNetworkId(networkId),
                    rpcUrl,
                } });
        }
        // Next should return configuration provided through settings
        if (this.configNetworkId === networkId) {
            return this._config;
        }
        if (networkId === 1) {
            return Object.assign(Object.assign({}, this._config), { network: 'mainnet' });
        }
        if (networkId === 5) {
            return Object.assign(Object.assign({}, this._config), { network: 'goerli' });
        }
        return this._config;
    }
    get configNetworkId() {
        var _a, _b, _c;
        if (typeof ((_a = this._config) === null || _a === void 0 ? void 0 : _a.network) !== 'string') {
            return (_c = (_b = this._config) === null || _b === void 0 ? void 0 : _b.network) === null || _c === void 0 ? void 0 : _c.chainId;
        }
        return undefined;
    }
    _getRpcUrlByNetworkId(networkId) {
        var _a;
        const evm = this.evmNetworks.find((evmNetwork) => evmNetwork.networkId === networkId);
        return ((_a = evm === null || evm === void 0 ? void 0 : evm.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || (evm === null || evm === void 0 ? void 0 : evm.rpcUrls[0]);
    }
    _getChainIdByNetworkId(networkId) {
        var _a;
        return (_a = this.evmNetworks.find((evmNetwork) => evmNetwork.networkId === networkId)) === null || _a === void 0 ? void 0 : _a.chainId;
    }
    get lastUsedNetworkId() {
        const savedNetworkIdText = localStorage.getItem(MagicClientNetworkHandler.lastUsedNetworkIdStorageKey);
        if (!savedNetworkIdText)
            return undefined;
        try {
            const networkId = parseInt(savedNetworkIdText);
            if (isNaN(networkId)) {
                return undefined;
            }
            return networkId;
        }
        catch (err) {
            logger.error(err);
            return undefined;
        }
    }
    set lastUsedNetworkId(networkId) {
        if (networkId === undefined) {
            localStorage.removeItem(MagicClientNetworkHandler.lastUsedNetworkIdStorageKey);
        }
        else {
            localStorage.setItem(MagicClientNetworkHandler.lastUsedNetworkIdStorageKey, networkId.toString());
        }
    }
}
MagicClientNetworkHandler.lastUsedNetworkIdStorageKey = 'magic-last-used-network-id';

export { MagicClientNetworkHandler };
